<template>
  <div>
    <el-header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item>账号信息</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="id_msg">
      <div class="list">
        <p>个人信息</p>
        <div class="msg_box">
          <div class="left_box">
            <div class="img_box"><i class="el-icon-s-custom"></i></div>
            <div class="text_box">
              <div>昵称</div>
              <div class="iphone">{{ user.name }}</div>
            </div>
          </div>
          <el-button class="btn_box" type="text" @click="editBtn(1)"
            >编辑</el-button
          >
        </div>
      </div>
      <div class="list list_top">
        <p>登录密码</p>
        <div class="msg_box">
          <div class="left_box">
            <span>{{ user.loginPwd === '' ? '未设置' : '已设置' }}</span>
          </div>
          <el-button class="btn_box" type="text" @click="editBtn(2)">{{
            user.loginPwd === '' ? '设置' : '重置'
          }}</el-button>
        </div>
      </div>
      <div class="list list_top">
        <p>绑定手机号</p>
        <div class="msg_box">
          <div class="left_box">
            <span>{{ user.loginName }}</span>
          </div>
          <el-button class="btn_box" type="text" @click="editBtn(3)"
            >更换</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      center
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div>
        <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
          <div v-if="validId">
            <div style="padding-bottom: 20px">
              为保护账号安全，请使用{{ user.loginName }}验证身份
            </div>
            <el-form-item prop="code">
              <el-input
                size="small"
                v-model="ruleForm.code"
                placeholder="请输入验证码"
              >
                <el-tooltip slot="suffix" content="点击获取验证码">
                  <SendSmsCode
                    :telephone="user.loginName"
                    smsType="login"
                    ref="code1"
                  />
                </el-tooltip>
              </el-input>
            </el-form-item>
            <el-button
              style="width: 100%"
              size="small"
              type="primary"
              @click="validIdBtn"
              >下一步</el-button
            >
          </div>
          <div v-if="dialogNum === 1 && !validId">
            <el-form-item
              prop="name"
              :rules="[{ required: true, message: '请输入' }]"
            >
              <el-input
                size="small"
                v-model="ruleForm.name"
                placeholder="请输昵称"
              ></el-input>
            </el-form-item>
            <el-button
              style="width: 100%"
              size="small"
              type="primary"
              @click="supreBtn(1)"
              >确 定</el-button
            >
          </div>
          <div v-if="dialogNum === 2 && !validId">
            <el-form-item prop="psd">
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="line-height: 20px">
                  <p>长度为8-14个字符</p>
                  <p>密码要求至少一个大写字母、一个小写字母和一个数字</p>
                  <p>不允许有空格中文</p>
                </div>
                <el-input
                  size="small"
                  v-model="ruleForm.pwd1"
                  placeholder="请输入密码"
                  show-password
                ></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item prop="psd2">
              <el-input
                size="small"
                v-model="ruleForm.pwd2"
                placeholder="请确认密码"
                show-password
              ></el-input>
            </el-form-item>
            <el-button
              style="width: 100%"
              size="small"
              type="primary"
              @click="supreBtn(2)"
              >确 定</el-button
            >
          </div>
          <div v-if="dialogNum === 3 && !validId">
            <el-form-item
              prop="iphone"
              :rules="[{ required: true, message: '请输入' }]"
            >
              <el-input
                size="small"
                v-model="ruleForm.iphone"
                placeholder="请输入新的手机号"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                size="small"
                v-model="ruleForm.code"
                placeholder="请输入验证码"
              >
                <el-tooltip slot="suffix" content="点击获取验证码">
                  <SendSmsCodeR
                    :telephone="ruleForm.iphone"
                    smsType="reg"
                    ref="code2"
                  />
                </el-tooltip>
              </el-input>
            </el-form-item>
            <el-button
              style="width: 100%"
              size="small"
              type="primary"
              @click="supreBtn(3)"
              >确 定</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { WEB_USER } from '@/utils/constant'
import {
  updateName,
  updatePwd,
  changePhoneNumber,
  validPhoneCode
} from '@/api/user/user.js'
import SendSmsCode from '@/components/SendSmsCode'
import SendSmsCodeR from '@/components/SendSmsCode/indexR.vue'
export default {
  components: {
    SendSmsCode,
    SendSmsCodeR
  },
  data() {
    return {
      user: {
        name: ''
      },
      dialogVisible: false,
      ifPsd: false,
      validId: false,
      dialogNum: 1,
      dialogTitle: '修改昵称',
      newPhone: false,
      ruleForm: {
        name: ''
      }
    }
  },
  mounted() {
    this.user = JSON.parse(window.sessionStorage.getItem(WEB_USER))
  },
  methods: {
    editBtn(v) {
      if (v === 1) {
        // 编辑昵称
        this.validId = false
        this.ruleForm.name = this.user.name || ''
        this.dialogNum = 1
        this.dialogTitle = '修改昵称'
      }
      if (v === 2) {
        // 设置/重置密码
        this.validId = true
        this.dialogNum = 2

        this.dialogTitle = this.user.loginPwd === '' ? '设置密码' : '重置密码'
      }
      if (v === 3) {
        // 更换手机号
        this.validId = true
        this.dialogNum = 3
        this.dialogTitle = '更换手机号'
      }
      this.dialogVisible = true
    },
    supreBtn(v) {
      if (v === 1) {
        // 修改昵称确认
        if (!this.ruleForm.name) {
          return this.$message.error('昵称不能为空')
        }
        const data = {
          name: this.ruleForm.name
        }
        updateName(data).then((res) => {
          if (res.success) {
            this.$message.success('昵称修改成功')
            window.sessionStorage.setItem(WEB_USER, JSON.stringify(res.result))
            setTimeout(() => {
              // 延迟刷新页面的逻辑
              location.reload() // 刷新当前页面
            }, 2000) // 延迟3秒后刷新页面
          } else {
            this.$message.error(res.message)
          }
        })
      }
      if (v === 2) {
        // 修改密码确认
        if (!this.ruleForm.pwd1) {
          return this.$message.error('密码不能为空')
        }
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]+$/
        if (!pattern.test(this.ruleForm.pwd1)) {
          return this.$message.error(
            '密码要求至少一个大写字母、一个小写字母和一个数字'
          )
        }
        if (this.ruleForm.pwd1 !== this.ruleForm.pwd2) {
          return this.$message.error('确认密码不一致')
        }

        const data = {
          loginPwd: this.ruleForm.pwd1
        }
        updatePwd(data).then((res) => {
          if (res.success) {
            this.$message.success('密码修改成功')
            this.user.loginPwd = 1
            window.sessionStorage.setItem(WEB_USER, JSON.stringify(this.user))
            setTimeout(() => {
              // 延迟刷新页面的逻辑
              location.reload() // 刷新当前页面
            }, 2000) // 延迟3秒后刷新页面
          } else {
            this.$message.error(res.message)
          }
        })
      }
      if (v === 3) {
        // 修改手机号确认
        if (!this.ruleForm.code) {
          return this.$message.error('验证码不能为空')
        }
        const data = {
          code: this.ruleForm.code,
          phone: this.ruleForm.iphone
        }
        changePhoneNumber(data).then((res) => {
          if (res.success) {
            this.$message.success('手机号码修改成功')
            window.sessionStorage.setItem(WEB_USER, JSON.stringify(res.result))
            setTimeout(() => {
              // 延迟刷新页面的逻辑
              location.reload() // 刷新当前页面
            }, 2000) // 延迟3秒后刷新页面
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    validIdBtn() {
      // 更换手机号下一步
      if (!this.ruleForm.code) {
        return this.$message.error('验证码不能为空')
      }
      const data = {
        code: this.ruleForm.code
      }
      validPhoneCode(data).then((res) => {
        this.ruleForm.code = ''
        if (res.success) {
          this.validId = false
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.id_msg {
  background: #fff;
  padding: 20px;

  .list_top {
    padding-top: 20px;
  }

  .list {
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;

    p {
      font-weight: bold;
    }

    .msg_box {
      display: flex;
      margin-top: 20px;

      .left_box {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 16px;

        .iphone {
          font-weight: bold;
          padding-top: 8px;
        }

        .img_box {
          width: 50px;
          height: 50px;
          color: #fff;
          text-align: center;
          line-height: 50px;
          background: #1890ff;
          border-radius: 100%;
          font-size: 30px;
          margin-right: 10px;
        }
      }

      .btn_box {
        float: right;
      }
    }
  }
}
</style>
